export interface Interest {
    person: InterestPerson;
    address: InterestAddress;
    choices: InterestChoices;
    metadata?: InterestMetadata;
}

export enum InterestPersonTitle {
    MR = 'M',
    MS = 'Mme',
}

export interface InterestPerson {
    title?: InterestPersonTitle;
    lastName: string;
    firstName: string;
    phone: string;
    email?: string;
}

export interface InterestAddress {
    city: string;
    postalCode: string;
    streetNumber: string;
    street: string;
    extension?: string;
    inseeCode?: string;
    streetCode?: string;
}

export enum INTEREST_TECHNOLOGY {
    FTTH = 'ftth',
    BOX_4G = '4gbox',
    CROZON = 'crozon',
}

export interface InterestChoices {
    technology: INTEREST_TECHNOLOGY;
    isRelocation: boolean;
    authorizeCall: boolean;
    authorizeSmsOrEmail: boolean;
}

export interface InterestMetadata {
    login?: string;
    siteCode?: string;
    pointOfSaleCode?: string;
    clientId?: string;
}
